// src/hooks/useThemeSync.ts
// Applies the current theme/density (uiSlice, persisted to localStorage) to
// the document root as data attributes — src/styles/index.css keys its CSS
// variable overrides off `[data-theme]`/`[data-density]` on :root.
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export function useThemeSync() {
  const { theme, density } = useSelector((s: RootState) => s.ui);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-density', density);
  }, [density]);
}
